import React from 'react';
import { area } from 'd3-shape';
import { ScaleLinear } from 'd3-scale';

import styles from './Area.module.scss';

interface AreaProps {
  xScale: ScaleLinear<number, number, never>;
  yScale: ScaleLinear<number, number, never>;
  height: number;
  stream: {
    convertedElevation: number[];
    convertedDistance: number[];
  };
  clipPath?: string;
  fill?: string;
}

type FormatData = {
  elev: number;
  dist: number;
};

const Area = ({
  stream,
  xScale,
  yScale,
  height,
  clipPath,
  fill = 'rgba(100, 100, 100, 0.66)'
}: AreaProps) => {
  const formatData: FormatData[] = stream.convertedElevation.map(
    (elev, index) => ({
      elev,
      dist: stream.convertedDistance[index] ?? 0
    })
  );

  const drawArea = area<FormatData>()
    .x((d) => xScale(d.dist))
    .y1((d) => yScale(d.elev))
    .y0(height);

  return (
    <g className="AreaGroup" clipPath={clipPath}>
      <path
        className={styles.area}
        fill={fill}
        d={drawArea(formatData) ?? ''}
      />
    </g>
  );
};

export default Area;
